// @ts-ignore
import butler from "../assets/oyster.webp";
// @ts-ignore
import gun from "../assets/gun.png";
import { useState, useRef } from "react";
import { Link, useNavigate } from "react-router";
import AnimatedInputPlaceholder from "../components/AnimatedInputPlaceholder";
import { ImageCarousel } from "@/components/Home/ImageSection";
import { Button } from "@/components/ui/button";
import { motion, useInView, useScroll } from "framer-motion";

export const FrontPage = () => {
  return (
    <div className="w-full mx-auto text-primary min-h-[200vh] bg-gray-700">
      <div className="h-screen" />

      {/* This is where the content starts */}
      <div className="h-screen bg-gray-700 p-4 z-0">
        <ChatPreviewSection />
      </div>

      <ImageCarousel className="w-full z-50" />
      {/* this is actually blank space where the image carousel is */}
    </div>
  );
};

const ChatPreviewSection = () => {
  const navigate = useNavigate();
  const scrollYProgress = useScroll();
  const [scrollY, setScrollY] = useState(0);
  const [input, setInput] = useState("");
  const onSubmit = async (input: string) => {
    const query = encodeURIComponent(input);
    navigate(`/app/chat?query=${query}`, {
      viewTransition: true,
    });
  };
  return (
    <motion.div className="h-full relative rounded-2xl border-gray-50 bg-gray-50 py-80 flex flex-col justify-center items-center">
      <motion.img
        src={gun}
        alt="Butler Logo"
        className="w-2/5 mb-3 top-12 mix-blend-multiply rounded-xl"
      />
      <p>{scrollY}</p>
      <div className="h-full flex flex-col justify-center items-center text-center">
        <h1 className="mb-3 text-center w-full text-3xl font-serif tracking-wide leading-relaxed">
          Hi there, Welcome to Butler!
          <p>The world is your oyster - Start building!</p>
        </h1>
        <div className="flex gap-4">
          <Button
            type="button"
            variant="outline"
            className="my-13 text-2xl font-thin p-6 animate-pulse ring-2 ring-blue-500"
          >
            <Link to="/app">Home</Link>
          </Button>
          <Button
            type="button"
            variant="outline"
            className="my-13 text-2xl font-thin p-6 animate-pulse ring-2 ring-blue-500"
          >
            <Link to="/app/chat">Start here</Link>
          </Button>
        </div>
      </div>
      <div className="w-1/2 border-gray-500 border-2 mx-auto relative py-3 pl-8 pr-4 rounded-4xl group flex">
        <AnimatedInputPlaceholder
          placeholders={[
            "Create a weekly finance plan from my expenses",
            "Build a customer support query assistant",
            "Plan my tasks for the day, draft email responses from the past day",
            "Build a _________",
          ]}
          value={input}
          className="w-full text-2xl"
          inputClassName="flex-grow w-full focus:none border:none outline:none focus:outline-none"
          onChange={(e) => setInput(e.target.value)}
        />
        {/* <input className="flex-grow focus:none border:none outline:none focus:outline-none" placeholder="Create a weekly finance plan from my expenses"
              value={input}
              onChange={(e) => setInput(e.target.value)}/> */}
        <button
          type="button"
          className="rounded-full bg-blue-400/20 text-xl px-6"
          onClick={() => onSubmit(input)}
        >
          ↣
        </button>
      </div>
    </motion.div>
  );
};
